import React from 'react';
import { string, shape } from 'prop-types';
import backgroundColor from '../../lib/background-color';
import StyledLabel from '../styled-label';
import IconFactory from '../icons/factory-builder';

const namespace = 'ui-pdp-good-price-tag';

const GoodPriceTag = ({ icon, label, bg_color, label_type }) => (
  <div className={`${namespace}-wrapper`}>
    <div className={`${namespace} pl-8 pr-8 ${namespace}--${label_type} ${backgroundColor(bg_color)}`}>
      <StyledLabel as="span" {...label} />
      {IconFactory(icon)}
    </div>
  </div>
);

GoodPriceTag.propTypes = {
  icon: shape({
    id: string.isRequired,
    color: string,
  }).isRequired,
  label: shape({
    text: string,
    color: string,
  }).isRequired,
  bg_color: string.isRequired,
  label_type: string.isRequired,
};

GoodPriceTag.defaultProps = {};

export default React.memo(GoodPriceTag);
